import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CorporateFareIcon(props: IconProps) {
    return <Icon {...props} iconKey={"corporate_fare"}/>
}
